(() => {
  // -------- helpers ----------
  const $ = (s, r=document) => r.querySelector(s);

  function openDrawer() {
    const ce = $('cart-drawer');
    if (ce && typeof ce.open === 'function') { ce.open(); return true; }
    const btn = $('[aria-controls="CartDrawer"], [data-cart-toggle], .header-actions__cart-button, .header-actions__cart-icon');
    if (btn) { btn.click(); return true; }
    const details = $('#CartDrawer, [data-cart-drawer]');
    if (details && details.tagName?.toLowerCase() === 'details') { details.setAttribute('open',''); return true; }
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles:true, composed:true }));
    return false;
  }

  // Dispara varios nombres de evento que usan themes modernos (Horizon/Dawn-like)
  function fireCartUpdate(cart, didError = false) {
    const detail = { data: { didError, cart } };
    const evts = [
      'cart:update',          // común en muchos themes
      'cartUpdate',           // camelCase por si el enum transpila así
      'theme:cart:update'     // algunos themes namespaced
    ];
    const targets = [document, $('cart-drawer') || document];

    for (const name of evts) {
      for (const t of targets) {
        t.dispatchEvent(new CustomEvent(name, { detail, bubbles:true, composed:true }));
      }
    }
  }

  async function fetchCartJSON() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart.js failed');
    return res.json();
  }

  // -------- add to cart (modo Horizon) ----------
  async function addToCart(variantId, qty = 1, props = {}) {
    const body = new URLSearchParams({ id: String(variantId), quantity: String(qty), ...props }).toString(); // string!
    const res = await fetch('/cart/add', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body,
      credentials: 'same-origin'
    });

    let data = null;
    try { data = await res.clone().json(); } catch(_) {}

    if (!res.ok) {
      const err = data || { message: 'Add to cart failed', status: res.status };
      err.status = res.status;
      throw err;
    }
    return data;
  }

  // -------- listener principal ----------
  const inflight = new Map();

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-ajax-add][data-variant-id]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const id  = btn.getAttribute('data-variant-id');
    const qty = Number(btn.getAttribute('data-qty') || 1) || 1;
    if (!id || inflight.get(id)) return;

    inflight.set(id, true);
    btn.disabled = true;

    try {
      // Abre primero para que el theme “escuche” con el drawer visible
      openDrawer();

      await addToCart(id, qty);

      // Obtén el cart y dispara los eventos que el theme usa para refrescar UI
      const cart = await fetchCartJSON();
      fireCartUpdate(cart, false);
    } catch (err) {
      // Si es límite alcanzado, abre drawer para que se vea el mensaje del theme
      const msg = (err?.message || '').toLowerCase();
      if (err?.status === 422 || msg.includes('máxima') || msg.includes('maximum')) {
        openDrawer();
        try { const cart = await fetchCartJSON(); fireCartUpdate(cart, true); } catch(_) {}
      } else {
        console.warn('[ZC] add error', err);
        openDrawer();
      }
    } finally {
      btn.disabled = false;
      inflight.delete(id);
    }
  }, true);

  // Bloquea submits heredados que redirigen
  document.addEventListener('submit', (e) => {
    const submitter = e.submitter || document.activeElement;
    if (submitter && submitter.matches?.('[data-ajax-add]')) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    }
  }, true);
})();
